import styled from 'styled-components';

const ShellBody = styled.div.attrs(props => ({
  id: props?.id ?? 'main-content',
}))`
  flex-grow: 1;
`;

export default ShellBody;
